import { useTranslation } from "../../i18n";
import { statusTokenPrefix, type StatusSlug } from "./laneStatus";
import { statusLabel } from "./laneStatusConfig";

interface LaneStatusPillProps {
    status: StatusSlug;
    size?: "sm" | "lg";
}

const LaneStatusPill = ({ status, size = "sm" }: LaneStatusPillProps) => {
    const { language } = useTranslation();
    const prefix = statusTokenPrefix(status);
    const style: React.CSSProperties = {
        background: `var(--status-${prefix}-bg)`,
        color: `var(--status-${prefix}-fg)`,
        borderColor: `var(--status-${prefix}-border)`,
    };
    const className = `lanes-status-pill${size === "lg" ? " lanes-status-pill--lg" : ""}`;
    return (
        <span className={className} style={style}>
            {statusLabel(status, language)}
        </span>
    );
};

export default LaneStatusPill;
